/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('region.lift-tickets')
 */
import { RegionLayout } from 'page-components/region/_layout';
import Component, { getRegionLiftTicketsPageServerSideProps } from 'page-components/region/lift-tickets';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchRegionSlugs } from 'util/fetchStaticPageRegion';
import { packPaths } from 'util/packPaths';
import { isMainLocale } from 'util/i18nFlags'; */

export default Object.assign(Component, { Layout: RegionLayout });

export const getServerSideProps = propsWithI18NSSR(getRegionLiftTicketsPageServerSideProps);

/* export const getStaticPaths = async () => packPaths(
  isMainLocale()
    ? (await fetchRegionSlugs('region.lift-tickets'))
      .map((reg) => ({
        region: reg.slug,
      }))
    : [],
); */
